import { Input, Paper, TextField, Typography } from '@mui/material';
import React from 'react';
import { LanguageModel } from '../../../../config/types/models';
import { TranslationInput } from '../../../../config/types/custom/TranslationInput';
import { useTranslate } from 'react-admin';
import CustomRichText from '../../../../components/customRichText/CustomRichText';

type IProps = {
  description: string;
  translations: TranslationInput[];
  setDescription: (a: string) => void;
  setTranslations: (a: TranslationInput[]) => void;
  languages: LanguageModel[];
};

function ProductDescription({
  description,
  translations,
  setDescription,
  setTranslations,
  languages,
}: IProps) {
  const t = useTranslate();

  const onChangeTranslation = (lang: LanguageModel, val: string) => {
    const newTranslations = [
      ...translations.filter(
        (c) => !(c.languageId === lang.id && c.key === 'description')
      ),
      {
        languageId: lang.id,
        key: 'description',
        value: val,
      },
    ];
    setTranslations(newTranslations);
  };

  return (
    <Paper sx={{ padding: 2 }}>
      <Typography variant='subtitle1'>{t('productDescription')}</Typography>
      <CustomRichText
        content={description}
        placeholder={languages?.find((c) => c.isDefault === true)?.name || ''}
        onChange={(txt: string) => setDescription(txt)}
      />
      {languages
        ?.filter((c) => c.isDefault === false)
        .map((lang) => (
          <CustomRichText
            placeholder={lang.name}
            content={
              translations?.find(
                (c) => c.languageId === lang.id && c.key === 'description'
              )?.value || ''
            }
            onChange={(txt: string) => onChangeTranslation(lang, txt)}
          />
        ))}
    </Paper>
  );
}

export default ProductDescription;
